import { render, staticRenderFns } from "./AccountFormWrap.vue?vue&type=template&id=2a18a833"
import script from "./AccountFormWrap.vue?vue&type=script&lang=js"
export * from "./AccountFormWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports